import { render, staticRenderFns } from "./ModalSideBar.vue?vue&type=template&id=6fd1b074"
import script from "./ModalSideBar.vue?vue&type=script&lang=js"
export * from "./ModalSideBar.vue?vue&type=script&lang=js"
import style0 from "./ModalSideBar.vue?vue&type=style&index=0&id=6fd1b074&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports